import { render, staticRenderFns } from "./GetPoint.vue?vue&type=template&id=7f089d07&scoped=true&"
import script from "./GetPoint.vue?vue&type=script&lang=js&"
export * from "./GetPoint.vue?vue&type=script&lang=js&"
import style0 from "./GetPoint.vue?vue&type=style&index=0&id=7f089d07&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f089d07",
  null
  
)

export default component.exports